import React, { Component } from "react";
import { NavLink } from "react-router-dom";

export default class TestComponent extends Component {
  render() {
    return (
      <div>
        <div>Hello From the Test Component Page!</div>
        <div>
          <NavLink to="/sign_up">Sign Up</NavLink>
          <br />
          <NavLink to="/log_in">Log In</NavLink>
        </div>
      </div>
    );
  }
}
